import React from 'react'
import "./styles/Footer.css"

import { useNavigate } from "react-router-dom";

const Footer = () => {
    const navigate = useNavigate();

    return (
        <div className='Footer'>
            <a
                onClick={() => {
                    navigate("/privacy-policy");
                }}
            >Privacy Policy</a>
            <a
                onClick={() => {
                    navigate("/terms-and-conditions");
                }}
            >Terms and Conditions</a>
            <p>Made by: <a href='https://weareasite.com' target="_blank" and rel="noopener noreferrer">WE ARE A SITE LLC</a></p>
        </div>
    )
}

export default Footer